import ResponsiveImage from "./ResponsiveImage.vue"

export default {
    install(Vue) {
        Vue.component("ResponsiveImage", ResponsiveImage)
    },
}
